import { render, staticRenderFns } from "./zhuanyouzuo.vue?vue&type=template&id=2391bcdc&scoped=true&"
import script from "./zhuanyouzuo.vue?vue&type=script&lang=js&"
export * from "./zhuanyouzuo.vue?vue&type=script&lang=js&"
import style0 from "./zhuanyouzuo.vue?vue&type=style&index=0&id=2391bcdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2391bcdc",
  null
  
)

export default component.exports